import { PermissionsEnum } from '@/auth/interfaces';
import {
  EstadosOrdenTrabajoEnumChoice,
  useCheckPermissions,
  useTableFilter,
  useTableServerSideFiltering,
} from '@/shared';
import { useFetchOrdenTrabajos } from '@/shared/actions/erp';
import { GeneralTable, TableTabsScene } from '@/shared/components/ui';
import { OrdenTrabajo } from '@/shared/interfaces';
import { useColumnsInstalacionesOT } from '../../../shared/hooks';

export type InstallTecnicoOTByStateProps = {
  otState: EstadosOrdenTrabajoEnumChoice;
};

const InstallTecnicoOTByState: React.FC<
InstallTecnicoOTByStateProps
> = ({ otState }) => {
  useCheckPermissions(PermissionsEnum.api_view_ordentrabajo);

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: OrdensTrabajoPagingRes,
    isLoading,
    isRefetching,
  } = useFetchOrdenTrabajos({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      identificacion: searchTerm,
      ...filterObject,
      filterByState: false,
      estado_orden_trabajo: otState,
    },
  });

  ///* columns
  const {
    pylInstallPrerechazadaPendingColumns,
    instalacionesRealizadasColumns,
    instalacionesAsignadasTecnicoColumns,
  } = useColumnsInstalacionesOT();

  return (
    <TableTabsScene
      globalFilter={globalFilter}
      onChangeFilter={onChangeFilter}
      searchInputText="por identificación"
      onChangeRangeDate={onChangeRangeDate}
      cleanFilter={cleanFilter}
    >
      <GeneralTable<OrdenTrabajo>
        columns={
          otState === EstadosOrdenTrabajoEnumChoice.PRE_RECHAZADO
            ? pylInstallPrerechazadaPendingColumns
            : otState === EstadosOrdenTrabajoEnumChoice.RECHAZADA
            ? pylInstallPrerechazadaPendingColumns
            : otState === EstadosOrdenTrabajoEnumChoice.REALIZADA
            ? instalacionesRealizadasColumns
            : otState === EstadosOrdenTrabajoEnumChoice.EN_ESPERA ||
              otState === EstadosOrdenTrabajoEnumChoice.ESPERA_RECOORDINADA
            ? instalacionesAsignadasTecnicoColumns
            : []
        }
        data={OrdensTrabajoPagingRes?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={OrdensTrabajoPagingRes?.data?.count}
        // // actions ========
        enableColumnActions={false}
        enableEditing={false}
        // crud
        canEdit={false}
        canDelete={false}
      />
    </TableTabsScene>
  );
};

export default InstallTecnicoOTByState;
